import { render } from "./Restaurants.vue?vue&type=template&id=b4ca5634"
import script from "./Restaurants.vue?vue&type=script&lang=js"
export * from "./Restaurants.vue?vue&type=script&lang=js"
script.render = render

export default script